import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _MEDIA_QUERIES;

export var DEVICE_MOBILE = 'MOBILE';
export var DEVICE_TABLET = 'TABLET';
export var DEVICE_DESKTOP = 'DESKTOP';
var MOBILE_MQ = {
  BREAKPOINT: '(min-width: 0)',
  DEVICE: DEVICE_MOBILE
};
var TABLET_MQ = {
  BREAKPOINT: '(min-width: 768px)',
  DEVICE: DEVICE_TABLET
};
var DESKTOP_MQ = {
  BREAKPOINT: '(min-width: 992px)',
  DEVICE: DEVICE_DESKTOP
};
var BOOTSTRAP_MQ = [DESKTOP_MQ, TABLET_MQ, MOBILE_MQ];
var MEDIA_QUERIES = (_MEDIA_QUERIES = {}, _defineProperty(_MEDIA_QUERIES, DEVICE_DESKTOP, '(min-width: 992px)'), _defineProperty(_MEDIA_QUERIES, DEVICE_TABLET, '(min-width: 768px) and (max-width: 991px)'), _defineProperty(_MEDIA_QUERIES, DEVICE_MOBILE, '(max-width: 767px)'), _MEDIA_QUERIES);
var memoizedMediaQuery = null;

var matchMediaQuery = function matchMediaQuery() {
  if (process.server) {
    return MOBILE_MQ;
  }

  return BOOTSTRAP_MQ.find(function (_ref) {
    var BREAKPOINT = _ref.BREAKPOINT;
    return window.matchMedia(BREAKPOINT).matches;
  }) || MOBILE_MQ;
};

var getMediaQuery = function getMediaQuery() {
  if (!memoizedMediaQuery) {
    memoizedMediaQuery = matchMediaQuery();
  }

  return memoizedMediaQuery;
};

if (process.client) {
  BOOTSTRAP_MQ.forEach(function (_ref2) {
    var BREAKPOINT = _ref2.BREAKPOINT;
    var mql = window.matchMedia(BREAKPOINT);

    mql.onchange = function () {
      memoizedMediaQuery = matchMediaQuery();
    };
  });
}

export default {
  methods: {
    isMobile: function isMobile() {
      return getMediaQuery().DEVICE === DEVICE_MOBILE;
    },
    isTablet: function isTablet() {
      return getMediaQuery().DEVICE === DEVICE_TABLET;
    },
    isDesktop: function isDesktop() {
      return getMediaQuery().DEVICE === DEVICE_DESKTOP;
    },

    /**
    * Listen when user enters or exits the specified
    * display and execute the callback function
    *
    * @method listenMatchMedia
    * @param {String} device device to listen to (DESKTOP, TABLET or MOBILE)
    * @param {Function} callback callback function to call when matchMedia changes
    */
    listenMatchMedia: function listenMatchMedia(device, callback) {
      if (process.client) {
        if (!MEDIA_QUERIES[device]) {
          console.warn("\"".concat(device, "\" is not a valid device, use one of [").concat(Object.keys(MEDIA_QUERIES), "]"));
          return;
        }

        var mql = window.matchMedia(MEDIA_QUERIES[device]);
        mql.onchange = callback;
        this.$once('hook:beforeDestroy', function () {
          mql.onchange = null;
          mql = null;
        });
      }
    },

    /**
    * Check if the current display matches the specified breakpoint (equals and up)
    *
    * @method checkSpecialBreakpointUp
    * @param {String} breakpoint breakpoint to check (in px or rem, ex: '1025px')
    * @return {Boolean} Returns true on success
    */
    checkSpecialBreakpointUp: function checkSpecialBreakpointUp(breakpoint) {
      return window.matchMedia("(min-width: ".concat(breakpoint, ")")).matches;
    }
  }
};